/**
 * Form Container Editor
 * Handles configuration for form-container layout controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';
import { FormContainerPropertyPanel } from '@atlas-forms/controls-form-container-react';

/**
 * Render function for form-container control
 */
function renderFormContainerEditor(props: PropertyEditorProps) {
  const { control, onControlChange } = props;

  return (
    <div className="af-properties-tab__section">
      <FormContainerPropertyPanel
        control={control}
        onChange={(updated: any) => onControlChange({ config: updated.config })}
      />
    </div>
  );
}

/**
 * FormContainerEditor - Handles form-container control configuration
 */
export const FormContainerEditor: PropertyEditor = {
  type: 'form-container',
  label: 'Form Container',
  description: 'Configure nested form container layout',
  render: renderFormContainerEditor,
};
